
/**
 * Billing frequency
 */
export type GetPlans200ItemBillingCycle = typeof GetPlans200ItemBillingCycle[keyof typeof GetPlans200ItemBillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlans200ItemBillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  ONE_TIME: 'ONE_TIME',
} as const;
